import { render, staticRenderFns } from "./forgetPass.vue?vue&type=template&id=abdb8a16&scoped=true"
import script from "./forgetPass.vue?vue&type=script&lang=js"
export * from "./forgetPass.vue?vue&type=script&lang=js"
import style0 from "./forgetPass.vue?vue&type=style&index=0&id=abdb8a16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abdb8a16",
  null
  
)

export default component.exports